// extracted by mini-css-extract-plugin
export default {"OptionsHeading":"single-select-options-module__OptionsHeading--xOVn9","SingleSelectForm":"single-select-options-module__SingleSelectForm--mH0RZ"};